import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";
import { FlexLayoutModule, FlexModule } from "@ngbracket/ngx-layout";

import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatChipsModule } from "@angular/material/chips";
import { MatDialogModule } from "@angular/material/dialog";
import { MatDividerModule } from "@angular/material/divider";
import { MatIconModule } from "@angular/material/icon";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatTooltipModule } from "@angular/material/tooltip";

import { CommandsModule } from "@tylertech/commands-module";
import { LgdCheckboxModule, LgdDatePickerModule, LgdRadioGroupModule, LgdSelectModule, LgdTextAreaModule, LgdTextModule, LgdTypeAheadModule } from "@tylertech/lgd-reactive-forms";
import { CommonComponentsModule } from "@tylertech/common-components-module";
import { CoreModule } from "@tylertech/core-module";
import { CommonDialogsModule } from "@tylertech/common-dialogs-module";
import { IncodeModule } from "@tylertech/incode-module";
import { UserDefinedFieldsModule } from "@tylertech/user-defined-fields-module";
import { AttachmentsModule } from "@tylertech/attachments-module";

import
{
    AlertComponent,
    AlertListComponent,
    ContactManagerComponent,
    ContactManagerDialogComponent,
    MailingAddressCardComponent,
    MailingAddressComponent,
    MailingAddressDialogComponent,
    MailingAddressListComponent,
} from "./components";
import
{
    ContactDialogsService,
    ContactLookupService,
    ContactManagerService,
    ContactService,
    MailingAddressService,
    ServiceRequestContactSelectionService,
} from "./services";

const angularModules = [
    CommonModule,
    FlexModule,
    FlexLayoutModule,
    ReactiveFormsModule,
];

const angularMaterialModules = [
    MatButtonModule,
    MatCardModule,
    MatChipsModule,
    MatDialogModule,
    MatDividerModule,
    MatIconModule,
    MatProgressBarModule,
    MatTooltipModule,
];

const lgdModules = [
    CommandsModule,
    CommonComponentsModule,
    CoreModule,
    AttachmentsModule,
    CommonDialogsModule,
    CommonDialogsModule,
    IncodeModule,
    UserDefinedFieldsModule,
    LgdCheckboxModule,
    LgdDatePickerModule,
    LgdRadioGroupModule,
    LgdSelectModule,
    LgdTextModule,
    LgdTextAreaModule,
    LgdTypeAheadModule,
];

const exportableComponents = [
    ContactManagerComponent,
];

@NgModule({
    imports: [
        ...angularModules,
        ...angularMaterialModules,
        ...lgdModules
    ],
    declarations: [
        ...exportableComponents,
        AlertListComponent,
        AlertComponent,
        MailingAddressCardComponent,
        MailingAddressComponent,
        MailingAddressListComponent,
        ContactManagerDialogComponent,
        MailingAddressDialogComponent,
    ],
    exports: exportableComponents,
    providers: [
        ServiceRequestContactSelectionService,
        MailingAddressService,
        ContactManagerService,
        ContactDialogsService,
        ContactService,
        ContactLookupService,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ContactModule { }
